export const AUTH_ROLES = {
  ADMIN: 1,
  TEACHER: 2,
  PARENT: 3,
  STUDENT: 4,
};

export const normalizeRole = (role) => {
  if (typeof role === 'number') return role;
  const parsed = Number(role);
  return Number.isNaN(parsed) ? null : parsed;
};

export const getFullName = (user) =>
  [user?.first_name, user?.last_name].filter(Boolean).join(' ') || user?.name || user?.full_name || '';

export const getRoleLabel = (role) => {
  const normalized = normalizeRole(role);

  if (normalized === AUTH_ROLES.PARENT) return 'Parent';
  if (normalized === AUTH_ROLES.STUDENT) return 'Student';
  if (normalized === AUTH_ROLES.TEACHER) return 'Teacher';
  if (normalized === AUTH_ROLES.ADMIN) return 'Admin';

  return '';
};

export const isParentRole = (role) => normalizeRole(role) === AUTH_ROLES.PARENT;
export const isStudentRole = (role) => normalizeRole(role) === AUTH_ROLES.STUDENT;
export const isTeacherRole = (role) => normalizeRole(role) === AUTH_ROLES.TEACHER;
export const isAdminRole = (role) => normalizeRole(role) === AUTH_ROLES.ADMIN;

export const canAccessParentPages = (role) => isParentRole(role);
export const canAccessStudentClasses = (role) => isParentRole(role) || isStudentRole(role);

export const getLandingRouteForUser = (user) => {
  const role = normalizeRole(user?.role);

  if (role === AUTH_ROLES.PARENT) return '/parent';
  if (role === AUTH_ROLES.STUDENT) return '/parent/student-classes';
  if (role === AUTH_ROLES.TEACHER) return user?.slug ? `/teacher/${user.slug}` : '/';
  if (role === AUTH_ROLES.ADMIN) return '/admin/dashboard';

  return '/';
};
